import { DatePipe } from '@angular/common';
import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { DevicesOsUpdateStatusStates } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { OsUpdateStatusState } from '@rocksoft/osupdates-sdk';
import { Device } from '@rocksoft/shared';
import { RoomNumberComponent } from './room-number.container';
import { hoursDifferenceFromUtcNow } from './time-calculator';

@Component({
  selector: 'era-device-grid-item-ui',
  templateUrl: './device-grid-item.component.html',
  styleUrls: ['./device-grid-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RoomNumberComponent, FaIconComponent, NgbTooltip, DatePipe],
})
export class DeviceGridItemComponent {
  public readonly device = input.required<Device>();
  public readonly isSelected = input.required<boolean>();
  public readonly hasWarning = input.required<boolean>();
  public readonly osUpdateStatus = input.required<DevicesOsUpdateStatusStates.OSUpdateStatus>();
  public readonly isApplicationInSync = input.required<boolean>();
  public readonly isInUse = input.required<boolean>();

  osUpdateStatusState = OsUpdateStatusState;

  private _isOver24Hours: boolean;
  private _isOver48Hours: boolean;

  public get isOver24Hours(): boolean {
    return this._isOver24Hours;
  }

  public get isOver48Hours(): boolean {
    return this._isOver48Hours;
  }

  constructor() {
    effect(() => {
      const device = this.device();
      if (device?.lastSeen !== undefined && device?.lastSeen !== null) {
        this._isOver24Hours = hoursDifferenceFromUtcNow(new Date(device.lastSeen)) > 24;
        this._isOver48Hours = hoursDifferenceFromUtcNow(new Date(device.lastSeen)) > 48;
      }
    });
  }
}
